import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  IconButton,
  Grid,
  Avatar,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentIcon from "@mui/icons-material/Payment";
import gpay from "../Assets/Img/GooglePay.svg";
import creditdebitcard from "../Assets/Img/creditdebit.svg";
import netbanking from "../Assets/Img/netbanking.svg";
import upi from "../Assets/Img/upi.svg";
import AddPaymentMethodModal from "./AddPaymentMethodModal ";

const PaymentMethods = () => {
  const [expanded, setExpanded] = useState(false);
  const [openModal, setOpenModal] = useState(false); // ✅ modal state

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      p={3}
      sx={{
        width: "100%",
        // borderRadius: 2,
        // border: "1px solid rgba(221, 221, 221, 1)",
        boxShadow: 0,
        // backgroundColor: "#fff",
      }}
    >
      {" "}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" fontWeight={600}>
          Payment Methods
        </Typography>
        <Button
          sx={{
            border: "1px solid rgba(107, 142, 118, 1)",
            color: "rgba(107, 142, 118, 1)",
          }}
          variant="outlined"
          //   size="small"
          onClick={() => setOpenModal(true)} // ✅ open modal on click
        >
          + Add Payment Method
        </Button>
      </Box>
      {/* Credit & Debit Cards */}
      <Accordion
        expanded={expanded === "credit"}
        onChange={handleChange("credit")}
        disableGutters
        elevation={0}
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
          mb: 2,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              component="img"
              src={creditdebitcard}
              alt="Credit & Debit"
              sx={{
                width: 28,
                height: 28,
                objectFit: "contain",
                display: "block",
              }}
            />
            <Typography fontWeight={600}>Credit & Debit Cards</Typography>
            <Typography variant="caption" color="text.secondary">
              Visa, Mastercard, Rupay and more
            </Typography>
          </Stack>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={2}>
            {[
              {
                accountNo: "******1234",
                cardHolder: "Don Joe",
                expiry: "12/2032",
                cvv: "698",
              },
              {
                accountNo: "******1234",
                cardHolder: "Don Joe",
                expiry: "12/2032",
                cvv: "698",
              },
            ].map((card, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    p: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Top Row: Logo + Label on left, icons on right */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Box display="flex" alignItems="center">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                        alt="Mastercard"
                        style={{ height: 18, marginRight: 8 }}
                      />
                      <Typography fontWeight={600}>Master Card</Typography>
                    </Box>
                    <Box>
                      <IconButton>
                        <EditOutlinedIcon fontSize="small" />
                      </IconButton>
                      <IconButton color="error">
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* Bottom Row: All card details in a single row */}
                  <Box display="flex" flexWrap="wrap" gap={1.8}>
                    <Typography variant="body2">
                      Account No. : {card.accountNo}
                    </Typography>
                    <Typography variant="body2">
                      Card Holder : {card.cardHolder}
                    </Typography>
                    <Typography variant="body2">
                      Expiry Date: {card.expiry}
                    </Typography>
                    <Typography variant="body2">CVV: {card.cvv}</Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {/* UPI Options */}
      <Accordion
        expanded={expanded === "upi"}
        onChange={handleChange("upi")}
        disableGutters
        elevation={0}
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
          mb: 2,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              component="img"
              src={upi}
              alt="Credit & Debit"
              sx={{
                width: 28,
                height: 28,
                objectFit: "contain",
                display: "block",
              }}
            />{" "}
            <Typography fontWeight={600}>UPI Options</Typography>
            <Typography variant="caption" color="text.secondary">
              Pay directly from your bank account
            </Typography>
          </Stack>
        </AccordionSummary>

        {/* ✅ UPI Content */}
        <AccordionDetails>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              component="img"
              src={gpay}
              alt="google pay"
              sx={{ width: 40, height: 40 }}
            />{" "}
            {/* <Typography fontWeight={600}>Gpay</Typography> */}
            <Typography variant="body2" color="text.secondary">
              UPI ID - abc@okicici.com
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* Net Banking */}
      <Accordion
        expanded={expanded === "netbanking"}
        onChange={handleChange("netbanking")}
        disableGutters
        elevation={0}
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
          mb: 2,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              component="img"
              src={netbanking}
              alt="Credit & Debit"
              sx={{
                width: 28,
                height: 28,
                objectFit: "contain",
                display: "block",
              }}
            />{" "}
            <Typography fontWeight={600}>Net Banking</Typography>
            <Typography variant="caption" color="text.secondary">
              Visa, Mastercard, Rupay and more
            </Typography>
          </Stack>
        </AccordionSummary>
      </Accordion>
      <AddPaymentMethodModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
      />
    </Box>
  );
};

export default PaymentMethods;
